/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/tag_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/tag_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  include_archived: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/tag_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  include_archived: z.boolean(),
});
